import React from 'react';
import '../../styles/accordian.css';


function Accordion({ title, children, defaultOpen = false, className = "", actions = null }) {
    const [open, setOpen] = React.useState(defaultOpen);
  
    return (
      <div className={`accordion ${className}`}>
        <div
          className="accordion-header"
          onClick={(event) => {
            event.stopPropagation();
            setOpen(!open);
          }}
          style={{ cursor: "pointer" }}
        >
          <strong className="accordion-title">{title}</strong>
          <div className="accordion-header-tools">
            {actions ? (
              <div
                className="accordion-actions"
                onClick={(event) => event.stopPropagation()}
              >
                {actions}
              </div>
            ) : null}
            <span aria-hidden="true">{open ? "−" : "+"}</span>
          </div>
        </div>
  
        {open && <div className="accordion-body">{children}</div>}
      </div>
    );
  }

  export default Accordion;